import { CheckCircle2 } from 'lucide-react';
import { useEffect, useSyncExternalStore } from 'react';

import {
  dismissStatusToast,
  getStatusToast,
  subscribeStatusToast,
} from '../../../app/status-toast-store';

/** How long a status toast stays on screen before dismissing itself. */
export const STATUS_TOAST_DURATION_MS = 3000;

/**
 * Host for the PWA status toast (QA R2-15): a small, accessible confirmation
 * ("Cash payment recorded · #3") for actions whose dialog closes silently.
 *
 * The live region is rendered ALWAYS (empty when idle) — screen readers only
 * announce changes inside a region that already exists. Mounted once in the
 * root route; trigger it with `showStatusToast(message)`.
 */
export function StatusToast() {
  const toast = useSyncExternalStore(subscribeStatusToast, getStatusToast, getStatusToast);
  const toastId = toast?.id;

  useEffect(() => {
    if (toastId === undefined) return;
    const timer = setTimeout(dismissStatusToast, STATUS_TOAST_DURATION_MS);
    return () => clearTimeout(timer);
  }, [toastId]);

  return (
    <div
      role="status"
      aria-live="polite"
      className="pointer-events-none fixed inset-x-4 bottom-24 z-50 mx-auto max-w-sm"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      {toast ? (
        <div className="pointer-events-auto flex items-center gap-3 rounded-xl border border-border bg-card px-4 py-3 shadow-lg">
          <CheckCircle2 className="size-5 shrink-0 text-success" aria-hidden />
          <p className="jq-body-sm text-foreground">{toast.message}</p>
        </div>
      ) : null}
    </div>
  );
}
